import { AxiosInstance } from 'axios'
import {
  DeliveryPage,
  AreasData,
  DragCoordinates,
  PointFeatureCollection,
  OldAreaFeatureCollection,
} from '@/api/modules/delivery/types'
import { Success, ServerError } from '@/api/results'
import { mapAreas, mapPoints } from '@/api/modules/delivery/delivery.utils'

export function createDeliveryModule({
  axios,
  sentry,
  city,
}: {
  axios: AxiosInstance
  sentry: any
  city: string
}) {
  const baseUrlV4 = getBaseUrlV4(city)

  return {
    // TODO: Удалить после раскатки карты на v4
    async fetchOldPointsOfAreas() {
      try {
        const { data } = await axios.get<PointFeatureCollection>(
          `/${city}/geo/points/`,
        )

        return mapPoints(data)
      } catch (error) {
        sentry.captureException(`Не удалось загрузить список точек: ${error}`)
        return error
      }
    },
    // TODO: Удалить после раскатки карты на v4
    async fetchOldAreas() {
      try {
        const { data } = await axios.get<OldAreaFeatureCollection>(
          `/${city}/geo/areas/`,
        )

        return mapAreas(data)
      } catch (error) {
        sentry.captureException(`Не удалось загрузить области карты: ${error}`)
      }
    },
    async fetchAreasByCoordinates(coords: DragCoordinates) {
      try {
        const baseUrlV4 = getBaseUrlV4(city, {
          withoutUuid: true,
          withoutCity: true,
        })

        const { data } = await axios.post<AreasData>(
          `${baseUrlV4}/geo/areas/`,
          {
            coords,
          },
        )

        return new Success(data)
      } catch (error) {
        sentry.captureException(
          `Не удалось загрузить динамически область карты: ${error}`,
        )
        return new ServerError('Что-то пошло не так. fetchAreasByCoordinates')
      }
    },
    async fetchAreas() {
      try {
        const { data } = await axios.get<AreasData>(`${baseUrlV4}/city/areas/`)

        return new Success(data)
      } catch (error) {
        sentry.captureException(`Не удалось загрузить области карты: ${error}`)
        return new ServerError('Что-то пошло не так. fetchAreas')
      }
    },
    async fetchPage() {
      try {
        const { data } = await axios.get<DeliveryPage>(`/${city}/delivery/`)

        return new Success(data)
      } catch (error) {
        sentry.captureException(
          `Не удалось загрузить страницу доставки: ${error}`,
        )
        return new ServerError('Что-то пошло не так. fetchPage(Delivery)')
      }
    },
  }
}
